import React from 'react';
import Chip from '@mui/material/Chip';

export default function EmailCell({ row }) {
  return (
    <span>
      {row.email}
      {row.is_self && <span style={{ marginLeft: 4, opacity: 0.7 }}>(you)</span>}
      {row.is_owner && <Chip label="Owner" size="small" variant="outlined" sx={{ ml: 1 }} />}
    </span>
  );
}
